(function () {
  "use strict";

  var root =
    document.getElementById("cpm-landing") ||
    document.getElementById("adhd-landing");
  if (!root) return;

  var CHECKOUT = root.getAttribute("data-checkout") || "";
  if (!CHECKOUT && root.id !== "adhd-landing") {
    CHECKOUT = "https://peacefulchildhood.com/cart/48913667293367:1?checkout";
  }
  var STORAGE_KEY =
    root.getAttribute("data-offer-key") || "pc-announcement-offer-ends-at";
  var WINDOW_MS = 4 * 60 * 60 * 1000;
  var lastFocus = null;
  var openModalEl = null;

  function pad(n) {
    return String(n).padStart(2, "0");
  }

  function getEndTarget() {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      var now = Date.now();
      if (stored) {
        var endsAt = Number(stored);
        if (!isNaN(endsAt) && endsAt > now) return endsAt;
      }
      var next = now + WINDOW_MS;
      localStorage.setItem(STORAGE_KEY, String(next));
      return next;
    } catch (e) {
      return Date.now() + WINDOW_MS;
    }
  }

  function initCountdown() {
    var active = root.querySelector("[data-cpm-countdown-active]");
    var expired = root.querySelector("[data-cpm-countdown-expired]");
    var display = root.querySelector("[data-cpm-countdown-display]");
    var sr = root.querySelector("[data-cpm-countdown-sr]");
    var pill = root.querySelector("[data-cpm-countdown]");
    if (!pill && !display) return;

    var endsAt = getEndTarget();

    function tick() {
      var diff = Math.max(0, endsAt - Date.now());
      if (diff <= 0) {
        if (active) active.hidden = true;
        if (expired) expired.hidden = false;
        return false;
      }
      if (active) active.hidden = false;
      if (expired) expired.hidden = true;
      var total = Math.floor(diff / 1000);
      var h = Math.floor(total / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;
      var formatted = pad(h) + ":" + pad(m) + ":" + pad(s);
      if (display) display.textContent = formatted;
      else if (pill) pill.textContent = formatted;
      if (sr) {
        sr.textContent =
          "Offer ends in " + h + " hours, " + m + " minutes, " + s + " seconds";
      }
      return true;
    }

    if (!tick()) return;
    setInterval(tick, 1000);
  }

  function initFaq() {
    var list = root.querySelector("[data-cpm-faq]");
    if (!list) return;

    var firstBtn = list.querySelector("[data-cpm-faq-btn]");
    var firstPanel = list.querySelector("[data-cpm-faq-panel]");
    if (firstBtn && firstPanel) {
      firstBtn.setAttribute("aria-expanded", "true");
      firstPanel.classList.add("is-open");
      firstPanel.hidden = false;
    }

    list.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-cpm-faq-btn]");
      if (!btn || !list.contains(btn)) return;
      var item = btn.closest("[data-cpm-faq-item]");
      var panel = item && item.querySelector("[data-cpm-faq-panel]");
      if (!panel) return;
      var isOpen = btn.getAttribute("aria-expanded") === "true";

      list.querySelectorAll("[data-cpm-faq-btn]").forEach(function (b) {
        b.setAttribute("aria-expanded", "false");
      });
      list.querySelectorAll("[data-cpm-faq-panel]").forEach(function (p) {
        p.classList.remove("is-open");
        p.hidden = true;
      });

      if (!isOpen) {
        btn.setAttribute("aria-expanded", "true");
        panel.classList.add("is-open");
        panel.hidden = false;
      }
    });
  }

  function getFocusable(modal) {
    return Array.prototype.slice.call(
      modal.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return !el.hasAttribute("disabled") && el.offsetParent !== null;
    });
  }

  function getModal(name) {
    return root.querySelector('[data-cpm-modal="' + name + '"]');
  }

  var READER_KEY = "pc-adhd-sample-scroll";

  function readerStorageKey(modal) {
    if (!modal) return READER_KEY;
    return modal.getAttribute("data-adhd-reader-key") || READER_KEY;
  }

  function syncReaderProgress(modal) {
    var scroller = modal && modal.querySelector("[data-adhd-reader-scroll]");
    var bar = modal && modal.querySelector("[data-adhd-reader-progress]");
    if (!scroller || !bar) return;
    var max = scroller.scrollHeight - scroller.clientHeight;
    var pct = max > 0 ? Math.min(100, (scroller.scrollTop / max) * 100) : 0;
    bar.style.width = pct + "%";
  }

  function restoreReaderPosition(modal) {
    var scroller = modal && modal.querySelector("[data-adhd-reader-scroll]");
    if (!scroller) return;
    try {
      var saved = Number(localStorage.getItem(readerStorageKey(modal)) || 0);
      if (!isNaN(saved) && saved > 0) scroller.scrollTop = saved;
      else scroller.scrollTop = 0;
    } catch (e) {
      scroller.scrollTop = 0;
    }
    syncReaderProgress(modal);
  }

  function persistReaderPosition(modal) {
    var scroller = modal && modal.querySelector("[data-adhd-reader-scroll]");
    if (!scroller) return;
    try {
      localStorage.setItem(readerStorageKey(modal), String(scroller.scrollTop));
    } catch (e) {}
  }

  function openModal(name) {
    var modal = getModal(name);
    if (!modal) return;
    lastFocus = document.activeElement;
    root.querySelectorAll("[data-cpm-modal]").forEach(function (m) {
      m.classList.remove("is-open");
      m.setAttribute("aria-hidden", "true");
    });
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    openModalEl = modal;
    document.body.style.overflow = "hidden";
    var closeBtn = modal.querySelector("[data-cpm-close]");
    var scroller = modal.querySelector("[data-adhd-reader-scroll]");
    setTimeout(function () {
      if (scroller) {
        restoreReaderPosition(modal);
        scroller.focus({ preventScroll: true });
      } else if (closeBtn) {
        closeBtn.focus();
      }
    }, 50);
  }

  function closeModals() {
    if (openModalEl) persistReaderPosition(openModalEl);
    root.querySelectorAll("[data-cpm-modal]").forEach(function (m) {
      m.classList.remove("is-open");
      m.setAttribute("aria-hidden", "true");
    });
    openModalEl = null;
    document.body.style.overflow = "";
    if (lastFocus && typeof lastFocus.focus === "function") {
      lastFocus.focus();
    }
    lastFocus = null;
  }

  function initModals() {
    root.addEventListener("click", function (e) {
      var openBtn = e.target.closest("[data-cpm-open]");
      if (openBtn && root.contains(openBtn)) {
        e.preventDefault();
        openModal(openBtn.getAttribute("data-cpm-open"));
        return;
      }
      if (e.target.closest("[data-cpm-close]")) {
        var closeEl = e.target.closest("[data-cpm-close]");
        if (closeEl.tagName === "A" && closeEl.getAttribute("href")) {
          closeModals();
          return;
        }
        e.preventDefault();
        closeModals();
        return;
      }
      if (e.target.matches("[data-cpm-modal-overlay]")) {
        closeModals();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        closeModals();
        return;
      }
      if (openModalEl && openModalEl.hasAttribute("data-adhd-reader")) {
        var scroller = openModalEl.querySelector("[data-adhd-reader-scroll]");
        var pageStep = Math.max(240, scroller ? scroller.clientHeight * 0.85 : 240);
        if (scroller && (e.key === "ArrowDown" || e.key === "PageDown" || e.key === "ArrowRight")) {
          e.preventDefault();
          scroller.scrollBy({
            top: pageStep,
            behavior: "smooth",
          });
          return;
        }
        if (scroller && (e.key === "ArrowUp" || e.key === "PageUp" || e.key === "ArrowLeft")) {
          e.preventDefault();
          scroller.scrollBy({
            top: -pageStep,
            behavior: "smooth",
          });
          return;
        }
      }
      if (e.key !== "Tab" || !openModalEl) return;
      var focusable = getFocusable(openModalEl);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    root.querySelectorAll("[data-adhd-reader-scroll]").forEach(function (reader) {
      reader.setAttribute("tabindex", "0");
      reader.addEventListener(
        "scroll",
        function () {
          var modal = reader.closest("[data-adhd-reader]");
          syncReaderProgress(modal);
          persistReaderPosition(modal);
        },
        { passive: true }
      );
    });
  }

  function initStickyCta() {
    var sticky = root.querySelector("[data-cpm-sticky-cta]");
    var hero =
      root.querySelector("#cpm-hero") ||
      root.querySelector("#adhd-hero") ||
      root.querySelector("[data-cpm-hero]");
    if (!sticky || !hero) return;
    var isAdhd = root.id === "adhd-landing";

    function onScroll() {
      var show = false;
      if (isAdhd) {
        var doc = document.documentElement;
        var max = doc.scrollHeight - window.innerHeight;
        var pct = max > 0 ? window.scrollY / max : 0;
        show = pct >= 0.4;
      } else {
        show = hero.getBoundingClientRect().bottom < 0;
      }
      if (show) sticky.classList.add("is-visible");
      else sticky.classList.remove("is-visible");
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  function setMenuOpen(toggle, menu, open) {
    var iconOpen = toggle.querySelector("[data-cpm-menu-icon-open]");
    var iconClose = toggle.querySelector("[data-cpm-menu-icon-close]");
    if (open) {
      menu.classList.add("is-open");
      menu.hidden = false;
      toggle.setAttribute("aria-expanded", "true");
      toggle.setAttribute("aria-label", "Close menu");
      if (iconOpen) iconOpen.hidden = true;
      if (iconClose) iconClose.hidden = false;
    } else {
      menu.classList.remove("is-open");
      menu.hidden = true;
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-label", "Open menu");
      if (iconOpen) iconOpen.hidden = false;
      if (iconClose) iconClose.hidden = true;
    }
  }

  function initMenu() {
    var toggle = root.querySelector("[data-cpm-menu-toggle]");
    var menu = root.querySelector("[data-cpm-menu]");
    if (!toggle || !menu) return;

    setMenuOpen(toggle, menu, false);

    toggle.addEventListener("click", function () {
      var open = !menu.classList.contains("is-open");
      setMenuOpen(toggle, menu, open);
    });

    menu.addEventListener("click", function (e) {
      if (e.target.closest("a")) setMenuOpen(toggle, menu, false);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") setMenuOpen(toggle, menu, false);
    });

    document.addEventListener("mousedown", function (e) {
      if (!menu.classList.contains("is-open")) return;
      if (menu.contains(e.target) || toggle.contains(e.target)) return;
      setMenuOpen(toggle, menu, false);
    });
  }

  function initNavScroll() {
    var nav = root.querySelector("[data-cpm-nav]");
    if (!nav) return;
    function onScroll() {
      if (window.scrollY > 16) nav.classList.add("is-scrolled");
      else nav.classList.remove("is-scrolled");
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  function initAnchors() {
    root.addEventListener("click", function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a || !root.contains(a)) return;
      var id = a.getAttribute("href");
      if (!id || id === "#") return;
      var target = root.querySelector(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  initCountdown();
  initFaq();
  initModals();
  initStickyCta();
  initMenu();
  initNavScroll();
  initAnchors();

  root.dataset.cpmCheckout = CHECKOUT;
})();
